// Reducer extracted from ChatContainerModule.js

import update from "immutability-helper";
import {
  UPDATE_CHAT_INFO,
  UPDATE_TEXT_BOX_FOCUS_STATE,
  SET_DRAFT_MESSAGE_DATA,
} from "./ChatContainerConstants";

// Initial State
const initialState = {
  isTextFocus: false,
  chatInfo: {
    parentId: null,
    parentType: "",
    conversationId: null,
    shouldMarkConversationAsRead: true,
  },
  draftMessageData: {},
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [UPDATE_CHAT_INFO]: (state, action) => {
    return update(state, { chatInfo: { $set: action.data } });
  },
  [UPDATE_TEXT_BOX_FOCUS_STATE]: (state, action) => {
    return update(state, { isTextFocus: { $set: action.data } });
  },
  [SET_DRAFT_MESSAGE_DATA]: (state, action) => {
    return {
      ...state,
      draftMessageData: { ...state.draftMessageData, ...action.data },
    };
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
